import { Tag } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const ClassifiersTagField = ({ value, fieldId }) => {
    const [classifiersTags, setClassifiersTags] = useState(value);

    useEffect(() => {
        setClassifiersTags(value);
    }, [value]);

    return classifiersTags && classifiersTags.length > 0 ? (
        <div className="flex gap-1">
            {classifiersTags.slice(0, 2).map((tag, index) => (
                <Tag key={fieldId ? `${fieldId}-${tag.tagId}` : `temp-${index}-${tag.tagId}`}>{tag.tagName}</Tag>
            ))}
        </div>
    ) : (
        <></>
    );
};

ClassifiersTagField.propTypes = {
    fieldId: PropTypes.string,
    value: PropTypes.array,
    onChange: PropTypes.func,
};

export default ClassifiersTagField;
